import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocStepper } from 'commons/components/components-wrapper/poc-stepper.component';
import { Select } from 'commons/components';
import styled, { css } from 'styled-components';

export const AutomationRulesPocCard = styled(PocCard)`
    width: 100%;
`;

interface AutomationRulesCardLayoutProps {
    padding?: string;
}

export const AutomationRulesCardLayout = styled.div<AutomationRulesCardLayoutProps>`
    display: flex;
    gap: 16px;
    padding: ${({ padding }) => padding || '24px'};

    &.spc-btw {
        justify-content: space-between;
    }

    &.col-dir {
        flex-flow: column;
    }

    &.alg-itm-ctr {
        align-items: center;
    }
`;

export const FlexDiv = styled.div`
    display: flex;
`;

export const AutomationRulesStepperStyled = styled(PocStepper)`
    overflow-y: unset !important;

    /* OWC-OVERRIDE: the automation-rules stepper is a layout device, not a navigation control
       — the steps are not clickable and must not read as active/in-progress. owc-step in
       v7.6.0 offers no non-interactive variant and no colour props for the status icon,
       icon container or divider, so each of those has to be neutralised by its own internal
       class. Revisit on the next @one upgrade. */
    .owc-step {
        cursor: auto;

        &:hover {
            .owc-step__slot-wrapper {
                background-color: unset;
            }
        }

        &.owc-step--status-default .owc-step__icon-container__icon,
        &.owc-step--status-in-progress .owc-step__icon-container__icon {
            color: #000;
            border: 0.125rem solid #000;
        }

        &.owc-step--status-in-progress {
            .owc-step__icon-container {
                color: unset;
            }

            .owc-step__icon-container__icon {
                background-color: unset;
            }

            .owc-step__divider {
                background-color: unset;
            }
        }

        &.owc-step--direction-vertical .owc-step__divider {
            background-color: unset;
        }
    }
`;

export const AutomationRulesSelect = styled(Select)<{ $hasContent?: boolean }>`
    padding: 0;

    ${({ $hasContent }) =>
        $hasContent &&
        css`
            div[slot='prefix'] {
                margin-left: 8px;
            }
        `}
`;

/* OWC-OVERRIDE (both containers): owc-select-dropdown sizes itself to its content in v7.6.0
   and exposes no width prop, so the rule columns would not line up; make it fill the fixed
   container width instead. Revisit on the next @one upgrade. */
export const FieldsContainer = styled.div`
    width: 240px;

    .owc-select-dropdown {
        width: 100%;
    }
`;

export const ActionOptionsContainer = styled.div`
    width: 350px;

    .owc-select-dropdown {
        width: 100%;
    }
`;

export const TrainingProgramPrefix = styled.div`
    color: var(--one-color-interaction-default-intensity-medium) !important;
`;
